import DashboardEficienciaPage from "./DashboardEficienciaPage.vue";

export {DashboardEficienciaPage}
export default DashboardEficienciaPage
